import React from "react";
import "../styles/ContactUs.css";
import { UserOutlined, PhoneOutlined, EnvironmentOutlined } from "@ant-design/icons";

const ContactUs = () => {
  return (
    <div className="contactus-wrapper">
      <div className="contactus-header">
        <h1 className="contactus-title">Contact Us</h1>
        <p className="contactus-desc">Any questions or remarks? Just write us a message!</p>
        <form className="contactus-form">
          <div className="contactus-form-row">
            <div className="contactus-form-group">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" placeholder="Enter a valid email address" />
            </div>
            <div className="contactus-form-group">
              <label htmlFor="name">Name</label>
              <input type="text" id="name" placeholder="Enter your Name" />
            </div>
          </div>
          <button type="submit" className="contactus-submit">SUBMIT</button>
        </form>
      </div>
      <div className="contactus-info-row">
        <div className="contactus-info-col">
          <div className="contactus-info-icon">
            <UserOutlined style={{ fontSize: 40, color: "var(--light-text)" }} />
          </div>
          <div className="contactus-info-title">ABOUT US</div>
          <div className="contactus-info-desc">JetSkill Online Learning<br/>Workshops & Guides</div>
        </div>
        <div className="contactus-info-col">
          <div className="contactus-info-icon">
            <PhoneOutlined style={{ fontSize: 40, color: "var(--light-text)" }} />
          </div>
          <div className="contactus-info-title">PHONE</div>
          <div className="contactus-info-desc">+84 123 456 789<br/>+84 987 654 321</div>
        </div>
        <div className="contactus-info-col">
          <div className="contactus-info-icon">
            <EnvironmentOutlined style={{ fontSize: 40, color: "var(--light-text)" }} />
          </div>
          <div className="contactus-info-title">OUR OFFICE LOCATION</div>
          <div className="contactus-info-desc">123 Nguyen Van Cu, Long Bien, Hanoi, Vietnam</div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs; 